export enum APPOINTMENT_TABS {
  OVERVIEW = 'overview',
  VISIT_SUMMARY_REPORT = 'visit_summary_report',
  DOCUMENTS = 'documents',
  NOTES = 'notes',
  HISTORY = 'history',
  DIAL_IN = 'dial_in',
  MEDCART = 'medcart',
}
